import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  type?: 'website' | 'article' | 'product' | 'service';
}

export default function SEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage = '/images/og-default.jpg',
  type = 'website'
}: SEOProps) {
  const location = useLocation();
  const baseUrl = window.location.origin;
  const fullUrl = canonicalUrl || `${baseUrl}${location.pathname}`;
  const fullTitle = `${title} | Fuel Central`;

  useEffect(() => {
    // Update page title
    document.title = fullTitle;

    // Update or create meta tags
    updateMetaTag('description', description);
    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    // Update canonical URL
    updateLinkTag('canonical', fullUrl);

    // Note: Open Graph and Twitter Cards removed per user request (no social media component)
  }, [fullTitle, description, keywords, fullUrl]);

  return null;
}

// Helper function to update meta tags
function updateMetaTag(name: string, content: string) {
  let element = document.querySelector(`meta[name="${name}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
}

// Helper function to update link tags
function updateLinkTag(rel: string, href: string) {
  let element = document.querySelector(`link[rel="${rel}"]`);

  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }

  element.setAttribute('href', href);
}
